import { render, staticRenderFns } from "./ViewGatGridMenu.vue?vue&type=template&id=fa7906bc&scoped=true&"
import script from "./ViewGatGridMenu.vue?vue&type=script&lang=js&"
export * from "./ViewGatGridMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7906bc",
  null
  
)

export default component.exports